import { RtcDetectionStepComponent } from '../rtc-detection-step-component.interface';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StepType } from '../rtc-detection.entities';

@Component({
    templateUrl: './step-no-camera-access.component.html',
    styleUrls: ['../rtc-detection.component.scss', './step-no-camera-access.component.scss']
})
export class StepNoCameraAccessComponent implements RtcDetectionStepComponent {
    nextStep: (arg) => void;
    dismissModal: () => void;
    closeModal: () => void;
    cancelStep: () => void;

    constructor(private translate: TranslateService) {
    }

    public again() {
        this.nextStep(StepType.CAM_TEST);
    }

    public getFAQInfo() {
        window.open('https://faq.patientus.de/portal/kb/articles/so-reaktivieren-sie-ihre-kamera', '_blank');
    }
}
